import DataTable, { Api } from 'datatables.net';
import $ from 'jquery';

$.extend(DataTable.ext.classes, {
  sWrapper: 'dataTables_wrapper dt-bootstrap4',
  sFilterInput: 'form-control form-control-sm',
  sLengthSelect: 'form-control form-control-sm',
  sProcessing: 'dataTables_processing card',
  sPageButton: 'paginate_button page-item',
  sInfo: 'card-footer d-flex align-items-center',
});

const table: Api<unknown> = new DataTable('.table', {
  paging: false,
  dom: 'ltipr',
  language: {
    processing: 'Traitement en cours...',
    search: 'Rechercher&nbsp;:&nbsp;',
    lengthMenu: 'Afficher _MENU_ &eacute;l&eacute;ments',
    info: "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
    infoEmpty: "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment",
    infoFiltered: '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
    infoPostFix: '',
    loadingRecords: 'Chargement en cours...',
    zeroRecords: 'Aucun &eacute;l&eacute;ment &agrave; afficher',
    emptyTable: 'Aucune donn&eacute;e disponible dans le tableau',
    paginate: {
      first: 'Premier',
      previous: 'Pr&eacute;c&eacute;dent',
      next: 'Suivant',
      last: 'Dernier',
    },
    aria: {
      sortAscending: ': activer pour trier la colonne par ordre croissant',
      sortDescending: ': activer pour trier la colonne par ordre d&eacute;croissant',
    },
  },
});

const filterbox = $('.filterbox');
filterbox.focus();
filterbox.keyup(function (this: HTMLElement) {
  table.search((this as HTMLInputElement).value).draw();
});
